import OwlCarousel from 'react-owl-carousel';
import { DashboardCricketMatch } from '../../../component';
import MatchTabHome from '../../../component/home_tab';
import MatchCardWrapper from '../../../component/match_card_wrapper';
import constants from '../../../constants';
import DefaultContainer from '../../default_container';
import './index.css';
import { useLink } from 'react-router-stack';
import { useDispatch, useSelector } from 'react-redux';
import { setIsDrawerOpen, updateGameType } from '../../../actions/user-actions-types';
import { addGameToHistory, setMiniGamesData } from '../../../actions/mini-games-action-types';
import { isBannedStateForPoker } from '../../../utilities/helper';
import GamesPoster from '../../../component/games_poster';
import { showToast } from '../../../actions/app-actions-types';
import { NewGamesPosters } from '../../../constants/poster_constants';
import Bottombar from '../../../component/bottom_bar';
import React from 'react';
import GamesPosterCard from '../../../component/games_poster_card';
import GuideTour from '../../../component/guide_tour';
import SpinTheWheel from '../../../component/spinTheWheel';
import SideDrawer from '../side_drawer';
import Footer from '../../../component/footer';

const HomePageMWeb = ({
  onViewAllMatchCard,
  suggestionsHandler,
  mainCarousalConfig,
  bannerImages,
  onClickSpinTheWheel,
  teamName,
  miniGamesList
}: any) => {
  const navigate = useLink();
  const { isDrawerOpen = false } = useSelector((state: any) => state.user);
  const currentLocationState = useSelector((state: any) => state.app.currentLocationState);
  const isBannedPoker = isBannedStateForPoker(currentLocationState);

  const dispatch = useDispatch();

  const onPressFantasyCricket = () => {
    dispatch(updateGameType(constants.GameType.FANTASY_CRICKET));
    navigate.push('/fantasy', {
      title: 'Fantasy Cricket',
      gameType: constants.GameType.FANTASY_CRICKET
    });
  };

  const onPressFantasyFootball = () => {
    dispatch(updateGameType(constants.GameType.FANTASY_FOOTBALL));
    navigate.push('/fantasy', {
      title: 'Fantasy Football',
      gameType: constants.GameType.FANTASY_FOOTBALL
    });
  };
  const onPressYesNo = () => {
    dispatch(updateGameType(constants.GameType.FANTASY_YES_NO));
    navigate.push('/fantasy', {
      title: 'Fantasy Yes/No',
      gameType: constants.GameType.FANTASY_YES_NO
    });
  };

  const onPressPoker = () => {
    if (isBannedPoker) {
      let message = 'Sorry, this game is not playable in your location ';
      message += currentLocationState ? ` "${currentLocationState}".` : '.';
      dispatch(showToast(message));
      return;
    }
    dispatch(updateGameType('POKER'));
    navigate.push('/poker');
  };
  const gameClickHandler = (game: any) => {
    dispatch(addGameToHistory(game));
    if (game.gameType && game.gameType === 'minigame') {
      dispatch(setMiniGamesData(game.gameData));
      navigate.push('/prizes');
    }
    if (game.game === 'cricket') {
      onPressFantasyCricket();
    }
    if (game.game === 'football') {
      onPressFantasyFootball();
    }
    if (game.game === 'poker') {
      onPressPoker();
    }
    if (game.game === 'yesorno') {
      onPressYesNo();
    }
    if (game.game === 'leaderboard') {
      navigate.push('/leaderboard_games');
    }
    if (game.game === 'pvp') {
      navigate.push('/pvp_games');
    }
  };
  const onPressToggleDrawer = () => {
    dispatch(setIsDrawerOpen(!isDrawerOpen));
  };
  const isGuideTourCompleted =
    localStorage.getItem(constants.GuideTour['home_page_mWeb'].key) === 'true';
  return (
    <>
      <DefaultContainer isWelcomeMessage={true}>
        <div className={'homePageCarousalAreaContainer'} id="home_page_mWeb">
          {!isGuideTourCompleted && teamName && (
            <GuideTour
              steps={constants.GuideTour['home_page_mWeb'].steps}
              keyValue={constants.GuideTour['home_page_mWeb'].key}
              elementId={'home_page_mWeb'}
            />
          )}
          <div className="fullWidth">
            <OwlCarousel className="owl-theme" {...mainCarousalConfig}>
              {bannerImages.length > 0 &&
                bannerImages.map((game: any) => (
                  <img
                    className="fullWidth"
                    src={game.image}
                    key={game.key}
                    style={{ padding: '1rem 1rem 0px 1rem' }}
                  />
                ))}
            </OwlCarousel>
          </div>
        </div>
        <div className="dailyRewards__spintTheWheel__img_wrapper__mWeb">
          <img
            className="spinTheWheel__img__mWeb"
            src={constants.Images.spinTheWheelMob}
            onClick={onClickSpinTheWheel}
          />
          <img
            className="dailyRewards__img__mWeb"
            src={constants.Images.dailyRewardsMob}
            onClick={() => navigate.push('daily_rewards')}
          />
        </div>
        <MatchTabHome />
        <GamesPoster games={NewGamesPosters} gameClickHandler={gameClickHandler} />

        <MatchCardWrapper
          iconSrc={constants.Images.fantasyCricketIcon}
          title={'Upcoming Cricket Matches'}
          onClickHandler={() => onViewAllMatchCard('cricketMatches')}>
          <DashboardCricketMatch />
        </MatchCardWrapper>
        <MatchCardWrapper
          iconSrc={constants.Images.leaderboard}
          title={'Leaderboard Games'}
          onClickHandler={() => {
            navigate.push('/leaderboard_games');
          }}>
          <div className="homepage_games_match_card_wrapper_mWeb">
            {miniGamesList
              .filter((item: any) => item.gameType !== 'playerVsPlayer')
              .map((item: any, idx: any) => (
                <React.Fragment key={idx}>
                  <GamesPosterCard
                    item={item}
                    idx={idx}
                    onGamePosterClick={suggestionsHandler}
                    isFooter={false}
                  />
                </React.Fragment>
              ))}
          </div>
        </MatchCardWrapper>
        <MatchCardWrapper
          iconSrc={constants.Images.playerVsPlayerGames}
          title={'Player VS Player Games'}
          onClickHandler={() => {
            navigate.push('/pvp_games');
          }}>
          <div className="homepage_games_match_card_wrapper_mWeb">
            {miniGamesList
              .filter((item: any) => item.gameType === 'playerVsPlayer')
              .map((item: any, idx: any) => (
                <React.Fragment key={idx}>
                  <GamesPosterCard
                    item={item}
                    idx={idx}
                    onGamePosterClick={suggestionsHandler}
                    isFooter={false}
                  />
                </React.Fragment>
              ))}
          </div>
        </MatchCardWrapper>
        <Footer />
        <SpinTheWheel />
        <SideDrawer drawerOpen={isDrawerOpen} onPressToggleDrawer={onPressToggleDrawer} />

        <Bottombar />
      </DefaultContainer>
    </>
  );
};

export default HomePageMWeb;
